export default "__VITE_ASSET__Be5A_vVJ__"